module.exports = __webpack_public_path__ + "static/img/page3-main.a39972bf.png";